import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from 'lucide-react';
import { forwardRef } from 'react';
export const SidebarSearch = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { onSearchClick } = param;
    return /*#__PURE__*/ _jsxs("button", {
        ref: ref,
        onClick: onSearchClick,
        className: "relative w-full flex items-center gap-3 h-9 px-3 rounded-md border border-border bg-input/30 hover:bg-input/40 transition-colors text-left cursor-pointer",
        children: [
            /*#__PURE__*/ _jsx(Search, {
                className: "h-4 w-4 text-muted-foreground"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text-sm text-muted-foreground",
                children: "Search..."
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-auto flex items-center gap-1",
                children: /*#__PURE__*/ _jsxs("kbd", {
                    className: "text-muted-foreground pointer-events-none h-5 select-none items-center gap-1 rounded-sm bg-background/80 px-1.5 font-mono text-[10px] font-medium sm:flex",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-xs",
                            children: "⌘"
                        }),
                        "K"
                    ]
                })
            })
        ]
    });
});
SidebarSearch.displayName = 'SidebarSearch';
